import * as Types from '../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type UpdateFieldOfficeProjectAffinityMutationVariables = Types.Exact<{
  input: Types.UpdateFieldOfficeProjectAffinityCommand;
}>;


export type UpdateFieldOfficeProjectAffinityMutation = { __typename?: 'MutationModel', fieldOffices: { __typename?: 'FieldOfficeMutationModel', updateProjectAffinity: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null }> } } };


export const UpdateFieldOfficeProjectAffinityDocument = gql`
    mutation UpdateFieldOfficeProjectAffinity($input: UpdateFieldOfficeProjectAffinityCommand!) {
  fieldOffices {
    updateProjectAffinity(input: $input) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type UpdateFieldOfficeProjectAffinityMutationFn = Apollo.MutationFunction<UpdateFieldOfficeProjectAffinityMutation, UpdateFieldOfficeProjectAffinityMutationVariables>;

/**
 * __useUpdateFieldOfficeProjectAffinityMutation__
 *
 * To run a mutation, you first call `useUpdateFieldOfficeProjectAffinityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldOfficeProjectAffinityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldOfficeProjectAffinityMutation, { data, loading, error }] = useUpdateFieldOfficeProjectAffinityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldOfficeProjectAffinityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldOfficeProjectAffinityMutation, UpdateFieldOfficeProjectAffinityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldOfficeProjectAffinityMutation, UpdateFieldOfficeProjectAffinityMutationVariables>(UpdateFieldOfficeProjectAffinityDocument, options);
      }
export type UpdateFieldOfficeProjectAffinityMutationHookResult = ReturnType<typeof useUpdateFieldOfficeProjectAffinityMutation>;
export type UpdateFieldOfficeProjectAffinityMutationResult = Apollo.MutationResult<UpdateFieldOfficeProjectAffinityMutation>;
export type UpdateFieldOfficeProjectAffinityMutationOptions = Apollo.BaseMutationOptions<UpdateFieldOfficeProjectAffinityMutation, UpdateFieldOfficeProjectAffinityMutationVariables>;